/* eslint-disable no-nested-ternary */
import React from 'react'
import { Stack, SxProps } from '@mui/material'
import { AlertIconProps } from './_props'

const AlertIcon: React.FC<AlertIconProps> = ({ icon, iconAlignment, sx, ...props }) => {
    const sxs: SxProps = Array.isArray(sx) ? sx : sx ? [sx] : []
    return (
        <Stack {...props} sx={[...sxs, { alignSelf: iconAlignment }]}>
            {icon}
        </Stack>
    )
}

export default AlertIcon
